// @ts-nocheck
document.addEventListener('DOMContentLoaded', () => {

  // ── DOM references ────────────────────────────────────────────────────────
  const cityLinks           = document.querySelectorAll('.store-locator-v2__city-item');
  const cards               = [...document.querySelectorAll('.store-card-v2')];
  const countEl             = document.getElementById('StoreLocatorCount');
  const mobileCountEl       = document.getElementById('StoreLocatorCountMobile');
  const mobileCityEl        = document.getElementById('StoreLocatorMobileCityName');
  const mobileTriggerTextEl = document.querySelector('.store-locator-v2__mobile-city-trigger-text');
  const searchInput         = document.getElementById('StoreLocatorCitySearch');
  const resultsHeaderEl     = document.getElementById('StoreLocatorResultsHeader');
  const paginationEl        = document.getElementById('StoreLocatorPagination');
  const paginationPagesEl   = document.getElementById('StoreLocatorPaginationPages');
  const drawerOverlay       = document.getElementById('StoreLocatorDrawerOverlay');
  const mobileTrigger       = document.getElementById('StoreLocatorMobileCityTrigger');
  const drawerCloseBtn      = document.getElementById('StoreLocatorDrawerClose');
  const drawerSearchInput   = document.getElementById('StoreLocatorDrawerSearch');
  const DESKTOP_PER_PAGE    = 6;
  const MOBILE_PER_PAGE     = 4;
  const MOBILE_BREAKPOINT   = 768;
  let perPage               = window.innerWidth < MOBILE_BREAKPOINT ? MOBILE_PER_PAGE : DESKTOP_PER_PAGE;

  // ── Module-level mutable state ────────────────────────────────────────────
  let currentCitySlug = '';
  let visibleCards    = [];
  let totalPages      = 1;
  let currentPage     = 1;

  // ── URL helpers ───────────────────────────────────────────────────────────
  const getSlugFromURL = () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const cityParam = params.get('city');
      if (cityParam && cityParam.toLowerCase() !== 'all') {
        return cityParam.toLowerCase().trim();
      }
    } catch (e) {}
    return '';
  };

  // ── Core filter function ──────────────────────────────────────────────────
  const applyFilter = (slug) => {
    currentCitySlug = slug;

    // 1. Update active state on all city links (sidebar + drawer share the same class)
    cityLinks.forEach((link) => {
      link.classList.remove('is-active');
      const linkSlug = (link.getAttribute('data-city-slug') || '').toLowerCase();
      const isAll   = slug === '' && linkSlug === 'all';
      const isMatch = slug !== '' && linkSlug === slug;
      if (isAll || isMatch) link.classList.add('is-active');
    });

    // 2. Recompute visible cards
    visibleCards = cards.filter((card) => {
      const cardSlug    = (card.getAttribute('data-city-slug') || '').toLowerCase();
      const isComingSoon = card.getAttribute('data-coming-soon') === 'true';
      if (isComingSoon) return slug !== '' && cardSlug === slug;
      return slug === '' || cardSlug === slug;
    });

    // 3. Update count displays
    const storeCount = visibleCards.filter(c => !c.dataset.comingSoon).length;
    if (countEl) countEl.textContent = storeCount;
    if (mobileCountEl) mobileCountEl.textContent = `${storeCount} Stores Found`;
    if (resultsHeaderEl) resultsHeaderEl.classList.toggle('is-hidden', storeCount === 0);

    // 4. Update mobile header city name and trigger button text
    const activeLink = document.querySelector('.store-locator-v2__city-item.is-active');
    const cityName   = activeLink ? (activeLink.getAttribute('data-city-name') || 'All Stores') : 'All Stores';
    if (mobileCityEl) mobileCityEl.textContent = cityName.toUpperCase();
    if (mobileTriggerTextEl) mobileTriggerTextEl.textContent = slug === '' ? 'Select Your City' : cityName;

    // 5. Rebuild pagination and show page 1
    rebuildPagination();
    showPage(1);
  };

  // ── Pagination ────────────────────────────────────────────────────────────
  const rebuildPagination = () => {
    totalPages = visibleCards.length <= 0 ? 1 : Math.ceil(visibleCards.length / perPage);

    if (!paginationEl || !paginationPagesEl) return;

    paginationPagesEl.innerHTML = '';
    for (let p = 1; p <= totalPages; p++) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'store-locator-v2__pagination-page';
      btn.setAttribute('data-page', p);
      btn.textContent = p;
      paginationPagesEl.appendChild(btn);
    }
  };

  const showPage = (page) => {
    currentPage = Math.max(1, Math.min(page, totalPages));

    cards.forEach((card) => {
      const idx  = visibleCards.indexOf(card);
      const show = idx !== -1 && idx >= (currentPage - 1) * perPage && idx < currentPage * perPage;
      card.classList.toggle('is-hidden', !show);
    });

    if (paginationEl) {
      paginationEl.classList.toggle('is-hidden', totalPages <= 1);
      const prevBtn = paginationEl.querySelector('.store-locator-v2__pagination-prev');
      const nextBtn = paginationEl.querySelector('.store-locator-v2__pagination-next');
      if (prevBtn) prevBtn.disabled = currentPage <= 1;
      if (nextBtn) nextBtn.disabled = currentPage >= totalPages;
    }

    if (paginationPagesEl) {
      paginationPagesEl.querySelectorAll('button').forEach((b) => {
        b.classList.toggle('is-active', parseInt(b.getAttribute('data-page'), 10) === currentPage);
      });
    }
  };

  // Delegated click handler for pagination — attached once, never re-bound
  if (paginationEl) {
    paginationEl.addEventListener('click', (e) => {
      const target = e.target;
      let changed  = false;
      if (target.classList.contains('store-locator-v2__pagination-page')) {
        showPage(parseInt(target.getAttribute('data-page'), 10));
        changed = true;
      } else if (target.classList.contains('store-locator-v2__pagination-prev')) {
        showPage(currentPage - 1);
        changed = true;
      } else if (target.classList.contains('store-locator-v2__pagination-next')) {
        showPage(currentPage + 1);
        changed = true;
      }
      if (changed) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }

  // ── Drawer ────────────────────────────────────────────────────────────────
  const resetDrawerSearch = () => {
    if (drawerSearchInput) drawerSearchInput.value = '';
    document.querySelectorAll('.store-locator-v2__drawer-city-item').forEach((link) => {
      link.classList.remove('is-hidden');
    });
    syncDrawerNoResults();
  };

  const openDrawer = () => {
    if (drawerOverlay) {
      drawerOverlay.classList.add('is-open');
      drawerOverlay.setAttribute('aria-hidden', 'false');
    }
    if (mobileTrigger) mobileTrigger.setAttribute('aria-expanded', 'true');
    const scrollY = window.pageYOffset;
    document.body.dataset.scrollY = scrollY;
    document.documentElement.style.setProperty('--scroll-y', `-${scrollY}px`);
    document.body.classList.add('scroll-lock');
    resetDrawerSearch();
  };

  const closeDrawer = () => {
    if (drawerOverlay) {
      drawerOverlay.classList.remove('is-open');
      drawerOverlay.setAttribute('aria-hidden', 'true');
    }
    if (mobileTrigger) mobileTrigger.setAttribute('aria-expanded', 'false');
    const scrollY = parseInt(document.body.dataset.scrollY || '0', 10);
    document.body.classList.remove('scroll-lock');
    document.documentElement.style.removeProperty('--scroll-y');
    delete document.body.dataset.scrollY;
    window.scrollTo(0, scrollY);
    resetDrawerSearch();
  };

  if (mobileTrigger) mobileTrigger.addEventListener('click', openDrawer);
  if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', closeDrawer);
  if (drawerOverlay) {
    drawerOverlay.addEventListener('click', (e) => {
      if (e.target === drawerOverlay) closeDrawer();
    });
  }

  // ── City link click handler (sidebar + drawer, single handler) ────────────
  cityLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();

      let slug = (link.getAttribute('data-city-slug') || '').toLowerCase();
      if (slug === 'all') slug = '';

      // Skip if already on this city
      if (slug === currentCitySlug) {
        if (link.classList.contains('store-locator-v2__drawer-city-item')) closeDrawer();
        return;
      }

      // Update URL without page reload
      try {
        const newURL = slug === ''
          ? window.location.pathname
          : `${window.location.pathname}?city=${slug}`;
        history.pushState({ city: slug }, '', newURL);
      } catch (ex) {}

      applyFilter(slug);

      // Close drawer if this was a drawer item
      if (link.classList.contains('store-locator-v2__drawer-city-item')) closeDrawer();
    });
  });

  // ── Browser back / forward ────────────────────────────────────────────────
  window.addEventListener('popstate', (e) => {
    const slug = (e.state && e.state.city != null) ? e.state.city : getSlugFromURL();
    applyFilter(slug);
  });

  // ── Sidebar city search ───────────────────────────────────────────────────
  if (searchInput) {
    const sidebarNoResults = document.getElementById('StoreLocatorNoResults');
    searchInput.addEventListener('input', (e) => {
      const query = e.target.value.toLowerCase().trim();
      let hasMatch = false;
      cityLinks.forEach((link, index) => {
        // Skip drawer items in the sidebar search
        if (link.classList.contains('store-locator-v2__drawer-city-item')) return;
        if (index === 0) { link.classList.remove('is-hidden'); return; }
        const name    = (link.getAttribute('data-city-name') || link.textContent).toLowerCase();
        const visible = name.includes(query);
        link.classList.toggle('is-hidden', !visible);
        if (visible) hasMatch = true;
      });
      if (sidebarNoResults) sidebarNoResults.classList.toggle('is-hidden', hasMatch || query === '');
    });
  }

  // ── Drawer city search ────────────────────────────────────────────────────
  const drawerNoResults = document.getElementById('StoreLocatorDrawerNoResults');

  const syncDrawerNoResults = () => {
    if (!drawerNoResults) return;
    const visibleCount = document.querySelectorAll(
      '.store-locator-v2__drawer-city-item:not(.is-hidden)'
    ).length;
    drawerNoResults.classList.toggle('is-hidden', visibleCount > 1);
  };

  if (drawerSearchInput) {
    drawerSearchInput.addEventListener('input', (e) => {
      const query = e.target.value.toLowerCase().trim();
      document.querySelectorAll('.store-locator-v2__drawer-city-item').forEach((link, index) => {
        if (index === 0) { link.classList.remove('is-hidden'); return; }
        const name    = (link.getAttribute('data-city-name') || link.textContent).toLowerCase();
        link.classList.toggle('is-hidden', !name.includes(query));
      });
      syncDrawerNoResults();
    });
  }

  // ── Open/closed status indicator ─────────────────────────────────────────
  const parseHour = (timeText) => {
    if (!timeText) return null;
    const match = timeText.trim().match(/^(\d+)(am|pm)$/i);
    if (!match) return null;
    let hour        = parseInt(match[1], 10);
    const period    = match[2].toLowerCase();
    if (period === 'pm' && hour !== 12) hour += 12;
    if (period === 'am' && hour === 12) hour = 0;
    return hour;
  };

  const statusEls = document.querySelectorAll('.store-status');
  if (statusEls.length) {
    const now         = new Date();
    const currentHour = now.getHours();
    statusEls.forEach((el) => {
      const openTime  = el.dataset.openTime;
      const closeTime = el.dataset.closeTime;
      const openHour  = parseHour(openTime);
      const closeHour = parseHour(closeTime);
      if (openHour == null || closeHour == null) return;
      const isOpen  = currentHour >= openHour && currentHour < closeHour;
      const labelEl = el.previousElementSibling;
      if (!labelEl) return;
      labelEl.textContent = isOpen ? 'Open' : 'Closed';
      labelEl.classList.toggle('is-open', isOpen);
      labelEl.classList.toggle('is-closed', !isOpen);
      el.textContent = isOpen ? `Closes ${closeTime}` : `Opens ${openTime}`;
    });
  }

  // ── Highlight today's row in weekly hours flyout ─────────────────────────
  // data-day-index: 0=Mon, 1=Tue, ..., 6=Sun
  // JS getDay():    0=Sun, 1=Mon, ..., 6=Sat
  const jsDayToIndex = [6, 0, 1, 2, 3, 4, 5];
  const todayIndex   = jsDayToIndex[new Date().getDay()];
  document.querySelectorAll('.store-card-v2__hours-row-detail').forEach((row) => {
    if (parseInt(row.getAttribute('data-day-index') || '-1', 10) === todayIndex) {
      row.classList.add('is-today');
    }
  });

  // ── Weekly hours flyout toggle ────────────────────────────────────────────
  document.querySelectorAll('.store-card-v2__hours-close-wrap').forEach((wrap) => {
    wrap.addEventListener('click', (e) => {
      if (e.target.closest('.store-card-v2__hours-flyout')) return;
      const wrapper = wrap.closest('.store-card-v2__hours-wrapper');
      if (wrapper) wrapper.classList.toggle('is-open');
    });
  });

  // ── Store card click → navigate to detail page ────────────────────────────
  cards.forEach((card) => {
    const url = card.getAttribute('data-store-url');
    if (!url) return;
    card.addEventListener('click', (event) => {
      const interactive = event.target.closest('a, button, .store-card-v2__hours-close-wrap');
      if (interactive && interactive !== card) return;
      window.location.href = url;
    });
    card.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        const activeEl = document.activeElement;
        if (activeEl && activeEl !== card && activeEl.closest('a, button')) return;
        event.preventDefault();
        window.location.href = url;
      }
    });
  });

  // ── Responsive per-page on resize ────────────────────────────────────────
  let resizeTimer = 0;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const newPerPage = window.innerWidth < MOBILE_BREAKPOINT ? MOBILE_PER_PAGE : DESKTOP_PER_PAGE;
      if (newPerPage !== perPage) {
        perPage = newPerPage;
        applyFilter(currentCitySlug);
      }
    }, 150);
  });

  // ── Initial render ────────────────────────────────────────────────────────
  // Stamp initial state onto the history entry so popstate always has e.state
  const initialSlug = getSlugFromURL();
  try {
    history.replaceState({ city: initialSlug }, '');
  } catch (ex) {}

  applyFilter(initialSlug);

  // ── Store card share buttons ──────────────────────────────────────────────
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.store-card-v2__share-btn');
    if (!btn) return;

    e.stopPropagation(); // prevent card navigation

    const card      = btn.closest('.store-card-v2');
    const storeName = btn.getAttribute('data-store-name') || document.title;
    const storeUrl  = (card && card.getAttribute('data-store-url')) || window.location.href;

    if (navigator.share) {
      navigator.share({ title: storeName, url: storeUrl }).catch(() => {});
    } else {
      navigator.clipboard.writeText(storeUrl).then(() => {
        btn.classList.add('is-copied');
        setTimeout(() => btn.classList.remove('is-copied'), 1800);
      });
    }
  });
});
